<template>
  <div>
    <v-row>
      <v-col class="text-h5 gray--text text--lighten-1">
        Adaptação da lente
      </v-col>
    </v-row>

    <v-row
      align="center"
      v-for="(row, rowIndex) in inputFieldsMatrix"
      :key="rowIndex"
    >
      <v-col v-for="(inputField, colIndex) in row" :key="colIndex">
        <v-combobox
          :value="inputField.value"
          @input="$emit(`update:${inputField.valueKey}`, $event)"
          dense
          hide-details
          outlined
          background-color="white"
          :menu-props="{ auto: true, maxHeight: 304 }"
          :label="inputField.name"
          :items="inputField.items"
          :disabled="inputField.disabled || isFormDisabled"
          @change="inputField.onChange"
        />
      </v-col>
    </v-row>

    <v-row dense align="center">
      <v-col>
        <v-textarea
          :value="notes"
          @input="changeNotes"
          label="Notas"
          v-uppercase
          dense
          hide-details
          outlined
          background-color="white"
          :disabled="isFormDisabled"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { sumLensValues } from "@/views/contact_lens_tests/form/sumLensValues.js";

export default {
  name: "ContactLensTestsFormLensAdaptationSection",
  props: {
    facilitators: Array,
    isFormDisabled: Boolean,
    hasContactLensTestLens: Boolean,

    contactLensSpherical: String,
    contactLensCylindrical: String,
    contactLensAxis: String,
    contactLensVisualAcuity: String,

    refractedSpherical: String,
    refractedCylindrical: String,
    refractedAxis: String,
    refractedVisualAcuity: String,

    finalSpherical: String,
    finalCylindrical: String,
    finalAxis: String,
    finalVisualAcuity: String,

    notes: String,
  },
  computed: {
    contactLensInputFields() {
      return [
        {
          name: "Esférico lente de contato",
          valueKey: "contactLensSpherical",
          facilitatorType: "spherical",
          onChange: () => this.changeSpherical(),
          disabled: this.hasContactLensTestLens,
        },
        {
          name: "Cilíndrico lente de contato",
          valueKey: "contactLensCylindrical",
          facilitatorType: "cylindrical",
          onChange: () => this.changeCylindrical(),
        },
        {
          name: "Eixo lente de contato",
          valueKey: "contactLensAxis",
          facilitatorType: "axis",
          onChange: () => this.changeAxis(),
        },
        {
          name: "Acuidade visual",
          valueKey: "contactLensVisualAcuity",
          facilitatorType: "visual_acuity",
          onChange: () => this.dispatchAutoSave(),
        },
      ];
    },
    refractedInputFields() {
      return [
        {
          name: "Esférico sobre refração",
          valueKey: "refractedSpherical",
          facilitatorType: "spherical",
          onChange: () => this.changeSpherical(),
        },
        {
          name: "Cilíndrico sobre refração",
          valueKey: "refractedCylindrical",
          facilitatorType: "cylindrical",
          onChange: () => this.changeCylindrical(),
        },
        {
          name: "Eixo sobre refração",
          valueKey: "refractedAxis",
          facilitatorType: "axis",
          onChange: () => this.changeAxis(),
        },
        {
          name: "Acuidade visual sobre refração",
          valueKey: "refractedVisualAcuity",
          facilitatorType: "visual_acuity",
          onChange: () => this.dispatchAutoSave(),
        },
      ];
    },
    finalInputFields() {
      return [
        {
          name: "Esférico final",
          valueKey: "finalSpherical",
          facilitatorType: "spherical",
          onChange: () => this.dispatchAutoSave(),
        },
        {
          name: "Cilíndrico final",
          valueKey: "finalCylindrical",
          facilitatorType: "cylindrical",
          onChange: () => this.dispatchAutoSave(),
        },
        {
          name: "Eixo final",
          valueKey: "finalAxis",
          facilitatorType: "axis",
          onChange: () => this.dispatchAutoSave(),
        },
        {
          name: "Acuidade visual final",
          valueKey: "finalVisualAcuity",
          facilitatorType: "visual_acuity",
          onChange: () => this.dispatchAutoSave(),
        },
      ];
    },
    inputFieldsMatrix() {
      return [
        this.computeInputFields(this.contactLensInputFields),
        this.computeInputFields(this.refractedInputFields),
        this.computeInputFields(this.finalInputFields),
      ];
    },
  },
  methods: {
    facilitatorsForType(facilitatorType) {
      const facilitator = this.lodash.find(this.facilitators, {
        facilitatorType,
      });

      return facilitator?.values || [];
    },
    changeSpherical() {
      this.$emit("change-spherical");
    },
    async changeCylindrical() {
      if (this.isFormDisabled) return;

      await this.$nextTick();

      const finalCylindrical = sumLensValues(
        this.contactLensCylindrical,
        this.refractedCylindrical
      );

      this.$emit("update:finalCylindrical", finalCylindrical);

      this.dispatchAutoSave();
    },

    async changeAxis() {
      if (this.isFormDisabled) return;

      await this.$nextTick();

      this.$emit("update:finalAxis", this.refractedAxis);

      this.dispatchAutoSave();
    },
    changeNotes(event) {
      this.$emit("update:notes", event);
      this.dispatchAutoSave();
    },
    dispatchAutoSave() {
      this.$emit("dispatch-auto-save");
    },
    computeInputFields(inputFields) {
      return inputFields.map((inputField) => {
        return this.computeInputFieldProperties(inputField);
      });
    },
    computeInputFieldProperties(inputField) {
      return {
        ...inputField,
        value: this[inputField.valueKey],
        items: this.facilitatorsForType(inputField.facilitatorType),
      };
    },
  },
};
</script>

<style></style>
